<div class="loader">
  <div class="custom-loader"></div>
</div>
